export const GROUP_KIND_TRAINING = "training";
export const GROUP_KIND_CHAMPIONSHIP = "championship";
export const GROUP_KIND_PING_SANTE = "ping_sante_bien_etre";
export const GROUP_KIND_PRESCRIPTION = "ping_sante_prescription";

export const GROUP_KINDS = [
  GROUP_KIND_TRAINING,
  GROUP_KIND_CHAMPIONSHIP,
  GROUP_KIND_PING_SANTE,
  GROUP_KIND_PRESCRIPTION,
];

export function capForGroupKind(kind) {
  if (kind === GROUP_KIND_PING_SANTE) return 12;
  if (kind === GROUP_KIND_PRESCRIPTION) return 8;
  return null;
}

export function normalizeGroupKind(value) {
  const kind = String(value || GROUP_KIND_TRAINING).trim();
  return GROUP_KINDS.includes(kind) ? kind : GROUP_KIND_TRAINING;
}
